import { render } from "./RwsSetupsList.vue?vue&type=template&id=682e725d"
import script from "./RwsSetupsList.vue?vue&type=script&lang=js"
export * from "./RwsSetupsList.vue?vue&type=script&lang=js"

import exportComponent from "/home/vol4/node/projects/robonomics/robonomics-dapp-new/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__